import React from "react";
import { useLocation } from "react-router-dom";
import styles from "./Layout.module.css";

const Footer: React.FC = () => {
  const location = useLocation();

  // ✅ Mostra footer SOLO nella homepage (mappa tutte le regioni)
  const isHomePage = location.pathname === "/" || location.pathname === "/home";
  // ✅ Nascondi se modal AI è aperto
  const isAIModalOpen = document.querySelector(".ai-modal-overlay") !== null;

  if (!isHomePage || isAIModalOpen) {
    return null;
  }

  return (
    <footer className={styles.footer}>
      <div>
        <p>© {new Date().getFullYear()} AI Hiking</p>

        <p className={styles.credits}>
          Developed with ❤️ by{" "}
          <a
            href="https://www.linkedin.com/in/marco-giuliani-08737325"
            className={styles.authorLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Marco Giuliani
          </a>
        </p>

        {/* Legal links */}
        <p className={styles.legal}>
          <a
            href="/legal/privacy-policy.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          {" · "}
          <a
            href="/legal/terms-of-service.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
